/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import jsonExport from "jsonexport/dist";

import { Grid, makeStyles, Typography, useMediaQuery } from "@material-ui/core";

import {
  Button,
  Confirm,
  downloadCSV,
  FilterButton,
  ListContextProvider,
  ListToolbar,
  NumberField,
  ReferenceField,
  SelectInput,
  TextField,
  TopToolbar,
  useList,
  useListContext,
  useNotify,
} from "react-admin";
import { useForm } from "react-final-form";

import {
  CopyIcon,
  CreateIcon,
  EditIcon,
  ExportIcon,
  ImportIcon,
} from "../../../components/common/iconography";
import { Pagination } from "../../../components/Pagination";
import { CustomField } from "../../../components/common/CustomFields";
import { SearchField } from "../../../components/common/SearchField";
import { LowInventoryIcon } from "../../../components/common/LowInventoryIcon";
import { isSubscriptionDisabled, logError } from "../../../utils/appUtils";
import { CatalogHeaderMap, Unit, UnitToColumn } from "../../../utils/constants";
import CustomizableDatagrid from "../../../components/common/ra-customizable-datagrid";
import { deepRedirect, exportCustomField } from "../../../utils/utils";
import { getTotalQuantityAvailable } from "../products/ProductUtils";

import { CatalogUploadDialog } from "./CatalogUploadDialog";
import { fetchProducts } from "./AccountUtils";
import { ColorField } from "../../../components/common/ColorField";

const useStyles = makeStyles((theme) => ({
  actionButton: {
    marginLeft: theme.spacing(1),
  },
  searchField: {
    minWidth: "16rem",
    marginTop: theme.spacing(3),
  },
}));

// Direct fetch allows account to load faster.
const fetchTabData = async (
  account,
  setAllProducts,
  setProducts,
  setLoading,
  notify,
) => {
  try {
    setLoading && setLoading(true);
    const allItems = (await fetchProducts(account.id)).map((product) => ({
      ...product,
      totalQuantityAvailable: getTotalQuantityAvailable(product),
    }));
    setAllProducts(allItems);
    setProducts && setProducts(allItems);
  } catch (error) {
    logError("ProductCatalogTab:fetchTabData", error, notify);
  } finally {
    setLoading && setLoading(false);
  }
};

const exportList = (products, account) => {
  debugger;
  const unitEntries = Object.entries(UnitToColumn).filter(
    (e) => e[0] !== Unit.CAR && e[0] !== Unit.TL,
  );
  const productsForExport = [];
  const headers = Object.keys(CatalogHeaderMap);
  const customHeaderMap = new Map();

  Object.values(products).forEach((product) => {
    let productExport = {
      productCode: product.productCode,
      name: product.name,
      reloadYardCommodityId:
        window.appUser.reloadYard.yardCommodityMap[
          product.reloadYardCommodityId
        ].commodity.name,
      category: product.category ? product.category : "",
      defaultUOM: product.defaultUOM,
      // defaultWeightUOM: product.defaultWeightUOM,
    };

    unitEntries.forEach(([unit, column]) => {
      productExport[column] = product[column];
    });

    productExport = {
      ...productExport,
      lowInventoryThreshold: product.lowInventoryThreshold,
      pcsHeight: product.pcsHeight,
      pcsWidth: product.pcsWidth,
      pcsLength: product.pcsLength,
      height: product.height,
      width: product.width,
      length: product.length,
    };

    if (product.customFields?.length > 0) {
      product.customFields.forEach((field) => {
        exportCustomField(field, productExport, customHeaderMap);
      });
    }

    debugger;
    productsForExport.push(productExport);
  });

  jsonExport(
    productsForExport,
    {
      rename: [...headers, ...customHeaderMap.keys()],
    },
    (err, csv) => {
      downloadCSV(csv, `${account.businessName}_products`); // download as 'products.csv` file
    },
  );
};

const ProductSearchField = (props) => {
  const classes = useStyles();
  const { allProducts, setProducts, label, alwaysOn } = props;

  const handleSearch = (value) => {
    debugger;
    const searchTerm = value?.toLowerCase() || "";
    const newProducts = allProducts.filter(
      (itm) =>
        itm.name?.toLowerCase().includes(searchTerm) ||
        itm.productCode?.toLowerCase().includes(searchTerm) ||
        itm.category?.toLowerCase().includes(searchTerm) ||
        itm.customFields?.join().toLowerCase().includes(searchTerm),
    );
    setProducts(newProducts);
  };

  return (
    <SearchField
      id="searchTerm"
      label={label}
      margin="dense"
      variant="outlined"
      alwaysOn={alwaysOn}
      className={classes.searchField}
      handleSearch={handleSearch}
      searchOnChange={true}
    />
  );
};

const getListFilters = (allProducts, setProducts) => [
  <ProductSearchField
    label="Catalog Search"
    allProducts={allProducts}
    setProducts={setProducts}
    alwaysOn
  />,
  <SelectInput
    // filtered directly by useList
    source="reloadYardCommodityId"
    label="Load Type"
    variant="outlined"
    resettable
    allowEmpty
    alwaysOn
    choices={window.appUser.reloadYard.activeYardCommodities.items}
    optionText="commodity.name"
    optionValue="id"
  />,
];

const ListActions = (props) => {
  const classes = useStyles();
  const [uploadOpen, setUploadOpen] = useState(false);

  const {
    account,
    allProducts,
    backPath,
    history,
    formState,
    openConfirm,
    hasCreate,
    handleRefresh,
  } = props;

  const handleCreate = () => {
    if (formState.dirty) openConfirm("/products/create", { account: account });
    else
      deepRedirect(history, "/products/create", backPath, { account: account });
  };

  return (
    <TopToolbar>
      <FilterButton />
      {hasCreate && (
        <Button
          label="Create"
          color="primary"
          className={classes.actionButton}
          onClick={handleCreate}
          disabled={isSubscriptionDisabled()}
        >
          <CreateIcon />
        </Button>
      )}
      <Button
        label="Import"
        color="primary"
        className={classes.actionButton}
        onClick={() => setUploadOpen(true)}
        disabled={isSubscriptionDisabled()}
      >
        <ImportIcon />
      </Button>
      <Button
        label="Export"
        size="small"
        color="primary"
        onClick={() => exportList(allProducts, account)}
        disabled={allProducts.length === 0}
      >
        <ExportIcon />
      </Button>
      {uploadOpen && (
        <CatalogUploadDialog
          account={account}
          existingProducts={allProducts}
          uploadOpen={uploadOpen}
          setUploadOpen={setUploadOpen}
          handleRefresh={handleRefresh}
        />
      )}
    </TopToolbar>
  );
};

const PaginationToolbar = (props) => {
  const listContext = useListContext(props);

  return (
    <Grid container direction="row" spacing={1} alignItems="center">
      <Grid item xs={4}>
        <Typography>
          {listContext?.selectedIds?.length > 0 ? (
            `${listContext.selectedIds.length} selected`
          ) : (
            <>&nbsp;</>
          )}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Pagination {...props} {...listContext} />
      </Grid>
    </Grid>
  );
};

const CloneButton = ({
  record,
  account,
  backPath,
  history,
  formState,
  openConfirm,
  ...props
}) => {
  const handleClone = (event) => {
    debugger;
    event.stopPropagation();
    if (formState.dirty)
      openConfirm("/products/create", { account: account, clone: record });
    else
      deepRedirect(history, "/products/create", backPath, {
        account: account,
        clone: record,
      });
  };

  return (
    <Button label="Clone" size="small" color="primary" onClick={handleClone}>
      <CopyIcon />
    </Button>
  );
};

const handleEdit = ({
  record,
  account,
  backPath,
  history,
  formState,
  openConfirm,
  event,
  ...props
}) => {
  debugger;
  if (event) {
    event.preventDefault();
    event.stopPropagation();
  }
  if (formState.dirty)
    openConfirm(`/products/${record.id}`, { account: account });
  else
    deepRedirect(history, `/products/${record.id}`, backPath, {
      account: account,
    });
};

const EditButton = (props) => {
  return (
    <Button
      label="Edit"
      size="small"
      color="primary"
      onClick={(event) => handleEdit({ ...props, event })}
    >
      <EditIcon />
    </Button>
  );
};

const CatalogGrid = (props) => {
  const lgDown = useMediaQuery((theme) => theme.breakpoints.down("lg"));
  const { account, backPath } = props;
  const hasBulkActions = false;
  const accountFields =
    account?.inventoryCustomFields?.length > 0
      ? account.inventoryCustomFields
      : [];
  const customGridFields = accountFields.map((field, index) => (
    <CustomField
      key={field.id}
      source={`customFields[${index}]`}
      field={field}
      label={field.name}
      sortable={false}
    />
  ));

  return lgDown ? (
    <CustomizableDatagrid
      rowClick={(id) => handleEdit({ ...props, backPath, record: { id } })}
      basePath="/products"
      hasBulkActions={hasBulkActions}
      storageProp={`ProductArrayList_${account?.id}_small`}
      defaultColumns={[
        "color",
        "productCode",
        "name",
        "pcs",
        "totalQuantityOnHand",
        "defaultUOM",
      ]}
    >
      {[
        <LowInventoryIcon sortable={false} />,
        <ColorField source="color" label="Color" />,
        <TextField source="productCode" label="Product Code" />,
        <TextField source="name" label="Name" />,
        <NumberField source="pcs" label="Pieces" />,
        <NumberField source="totalQuantityOnHand" label="On Hand" />,
        <NumberField source="totalQuantityCommitted" label="Committed" />,
        <NumberField source="totalQuantityAvailable" label="Available" />,
        <TextField source="defaultUOM" label="UOM" />,
        ...customGridFields,
        <CloneButton {...props} />,
      ]}
    </CustomizableDatagrid>
  ) : (
    <CustomizableDatagrid
      rowClick={(id) => handleEdit({ ...props, record: { id } })}
      basePath="/products"
      hasBulkActions={hasBulkActions}
      storageProp={`ProductArrayList_${account?.id}_large`}
      defaultColumns={[
        "LowInventoryIcon",
        "color",
        "productCode",
        "name",
        "reloadYardCommodityId",
        "lowInventoryThreshold",
        "totalQuantityOnHand",
        "defaultUOM",
      ]}
    >
      {[
        <LowInventoryIcon sortable={false} />,
        <ColorField source="color" label="Color" />,
        <TextField source="productCode" label="Product Code" />,
        <TextField source="name" label="Name" />,
        <ReferenceField
          source="reloadYardCommodityId"
          reference="reloadYardCommoditys"
          label="Load Type"
          link={false}
        >
          <TextField source="commodity.name" />
        </ReferenceField>,
        <NumberField source="pcs" label="Pieces" />,
        <TextField source="lowInventoryThreshold" label="Low Threshold" />,
        <NumberField source="totalQuantityOnHand" label="On Hand" />,
        <NumberField source="totalQuantityCommitted" label="Committed" />,
        <NumberField source="totalQuantityAvailable" label="Available" />,
        <TextField source="defaultUOM" label="UOM" />,
        ...customGridFields,
        <CloneButton {...props} />,
        <EditButton {...props} />,
      ]}
    </CustomizableDatagrid>
  );
};

export const ProductCatalogTab = ({
  account,
  allProducts,
  setAllProducts,
  backPath,
  classes,
  ...props
}) => {
  const form = useForm();
  const notify = useNotify();
  const history = useHistory();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(false);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [confirmState, setConfirmState] = useState({});
  const formState = form?.getState();
  const defaultSort = { field: "name", order: "ASC" };
  // const fixedFilter = { active: "true" };

  // memorize perPage settings
  // see useEffect [listContext?.perPage]) below
  const sessionPerPage = sessionStorage.getItem(`ProductCatalogTab`);
  const [defaultPerPage, setDefaultPerPage] = useState(
    sessionPerPage ? Number(sessionPerPage) : 10,
  );

  useEffect(() => {
    fetchTabData(account, setAllProducts, setProducts, setLoading, notify);
  }, []);

  const handleRefresh = () => {
    fetchTabData(account, setAllProducts, setProducts, null, notify);
  };

  const listContext = useList({
    ...props,
    data: products || [],
    ids: products?.map(({ id }) => id) || [],
    loading: loading,
    loaded: !loading || allProducts?.length > 0, // renders loading bars if false
    // filter: fixedFilter, // filtered in query
    sort: defaultSort,
    perPage: defaultPerPage,
    basePath: "/products",
    resource: "products",
  });

  useEffect(() => {
    if (listContext?.perPage) {
      sessionStorage.setItem(`ProductCatalogTab`, listContext.perPage);
      setDefaultPerPage(Number(listContext.perPage));
    }
  }, [listContext?.perPage]);

  const openConfirm = (redirectPath, state) => {
    setConfirmState({ redirectPath, state });
    setConfirmOpen(true);
  };

  const handleConfirm = () => {
    deepRedirect(
      history,
      confirmState.redirectPath,
      backPath,
      confirmState.state,
    );
  };

  return (
    <ListContextProvider value={listContext}>
      <ListToolbar
        {...props}
        filters={getListFilters(allProducts, setProducts)}
        actions={
          <ListActions
            account={account}
            allProducts={allProducts}
            history={history}
            backPath={backPath}
            formState={formState}
            openConfirm={openConfirm}
            handleRefresh={handleRefresh}
          />
        }
      />
      <CatalogGrid
        {...props}
        account={account}
        backPath={backPath}
        history={history}
        formState={formState}
        openConfirm={openConfirm}
      />
      <PaginationToolbar {...props} />
      <Confirm
        isOpen={confirmOpen}
        title="Save Confirmation"
        content="You have un-saved Account changes. If you continue, all changes will be lost. Proceed?"
        onConfirm={() => handleConfirm()}
        onClose={() => setConfirmOpen(false)}
      />
    </ListContextProvider>
  );
};
